import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { setupAppUpdate } from "@/utils/app-update";

/* 基本布局 */
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    cache: true                  缓存页面
    parentRoute:                 设置上级页面路由(二级页面需设置)
  }
*/

/*
 * 通用路由
*/
export const constantRoutes: RouteConfig[] = [
    {
        path: "/login",
        component: () => import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
        meta: { hidden: true }
    },
    {
        path: "/error",
        component: () =>
            import(/* webpackChunkName: "error" */ "@/views/error/error.vue"),
        meta: { hidden: true },
        name: "Error"
    },
    {
        path: "/",
        component: Layout,
        redirect: "/home",
        children: [
            {
                path: "home",
                component: () =>
                    import( /* webpackChunkName: "home" */ "@/views/home/console.vue"),
                name: "Home",
                meta: {
                    title: "工作台",
                    icon: "el-icon-picture-outline-round",
                }
            }
        ]
    },
];

export const asyncRoutes: RouteConfig[] = [

    {
        path: "/",
        component: Layout,
        children: [

            /*
            *数据中心
            */
            {
                path: '/partners',
                name: 'partners',
                component: () => import('@/views/club/partner/index.vue'),
                meta: { title: '合作者中心', icon: 'el-icon-user' },
            },
            {
                path: "/dataSummarize",
                component: () => import(/* webpackChunkName: "dataSummarize" */ "@/views/data/dataSummarize.vue"),
                name: "dataSummarize",
                meta: {
                    title: "数据概括",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/trafficAnalysis",
                component: () => import(/* webpackChunkName: "trafficAnalysis" */ "@/views/data/trafficAnalysis.vue"),
                name: "trafficAnalysis",
                meta: {
                    title: "流量分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/tradeAnalysis",
                component: () => import(/* webpackChunkName: "tradeAnalysis" */ "@/views/data/tradeAnalysis.vue"),
                name: "tradeAnalysis",
                meta: {
                    title: "交易分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/serviceAnalysis",
                component: () => import(/* webpackChunkName: "serviceAnalysis" */ "@/views/data/serviceAnalysis.vue"),
                name: "serviceAnalysis",
                meta: {
                    title: "服务分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: "/userAnalysis",
                component: () => import(/* webpackChunkName: "userAnalysis" */ "@/views/data/userAnalysis.vue"),
                name: "userAnalysis",
                meta: {
                    title: "用户分析",
                    icon: "el-icon-data",
                }
            },
            {
                path: 'plugin-unit',
                component: () => import(/* webpackChunkName: "talent-deduction" */ '@/views/plugin-manage/plugin-unit'),
                name: 'PluginUni',
                meta: {
                    title: '插件管理'
                }
            },
            {
                path: 'edit-unit',
                component: () => import(/* webpackChunkName: "talent-deduction" */ '@/views/plugin-manage/edit-unit'),
                name: 'EditUni',
                meta: {
                    title: '修改插件'
                }
            },

            /*
             * 用户管理
            */

            {
                path: "userlist",
                component: () => import(/* webpackChunkName: "userlist" */ "@/views/user/userList/userList.vue"),
                name: "UserList",
                meta: {
                    title: "平台账号",
                    icon: "el-icon-help",
                }
            },

            {
                path: "userinfo",
                component: () => import(/* webpackChunkName: "userinfo" */ "@/views/user/userList/userInfo/userInfo.vue"),
                name: "UserInfo",
                meta: {
                    title: "用户信息",
                    parentRoute: "/userlist",
                    cache: false
                },
            },


            {
                path: "newfeed",
                component: () => import(/* webpackChunkName: "newfeed" */ "@/views/user/feedBack/newFeed.vue"),
                name: "NewFeed",
                meta: {
                    title: "最新反馈",
                    icon: "el-icon-help",
                }
            },
            {
                path: "replyfeed",
                component: () => import(/* webpackChunkName: "replyfeed" */ "@/views/user/feedBack/replyFeed.vue"),
                name: "ReplyFeed",
                meta: {
                    title: "已回复反馈",
                    icon: "el-icon-help",
                }
            },

            {
                path: "loginMsg",
                component: () => import(/* webpackChunkName: "loginMsg" */ "@/views/user/loginMsg/loginInfo.vue"),
                name: "LoginMsg",
                meta: {
                    title: "登录日志",
                    icon: "el-icon-help",
                }
            },
            {
                path: "runrecord",
                component: () => import(/* webpackChunkName: "destroy" */ "@/views/user/runRecord/runRecord.vue"),
                name: "RunRecord",
                meta: {
                    title: "APP启动日志",
                    icon: "el-icon-help",
                }
            },



            /*
             * 系统管理
            */

            {
                path: "sensitive",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/sensitiveWords.vue"),
                name: "Sensitive",
                meta: {
                    title: "敏感词管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "admin-config",
                component: () => import(/* webpackChunkName: "admin" */ "@/views/permission/system/config/admin.vue"),
                name: "Admin",
                meta: {
                    title: "后台配置",
                    cache: false
                }
            },
            {
                path: "officialweb-config",
                component: () => import(/* webpackChunkName: "officialWeb" */ "@/views/permission/system/config/officialWeb.vue"),
                name: "OfficialWeb",
                meta: {
                    title: "官网配置",
                    cache: false
                }
            },
            {
                path: "minipro-config",
                component: () => import(/* webpackChunkName: "officialWeb" */ "@/views/permission/system/config/minipro.vue"),
                name: "minipro",
                meta: {
                    title: "小程序配置",
                    cache: false
                }
            },
            {
                path: "officialaccount-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/officialAccount.vue"),
                name: "OfficialAccount",
                meta: {
                    title: "公众号配置",
                    cache: false
                }
            },
            {
                path: "application-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/app.vue"),
                name: "Application",
                meta: {
                    title: "APP配置",
                    cache: false
                }
            },
            {
                path: "customer-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/customer.vue"),
                name: "CustomerConfig",
                meta: {
                    title: "客服配置",
                    cache: false
                }
            },
            {
                path: "order-config",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/order.vue"),
                name: "OrderConfig",
                meta: {
                    title: "订单配置",
                    cache: false
                }
            },

            {
                path: "send_mp_template",
                component: () => import(/* webpackChunkName: "sensitive" */ "@/views/permission/system/config/send_mp_template.vue"),
                name: "send_mp_template",
                meta: {
                    title: "发送模板消息",
                    cache: false
                }
            },

            {
                path: "topicmanage",
                component: () => import(/* webpackChunkName: "topicmanage" */ "@/views/permission/resource/topicManage.vue"),
                name: "TopicManage",
                meta: {
                    title: "话题管理",
                    icon: "icon-caiwu",
                }
            },


            {
                path: "app-banner",
                component: () => import(/* webpackChunkName: "Appbanner" */ "@/views/permission/resource/banner.vue"),
                name: "Appbanner",
                meta: {
                    title: "APP轮播图",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "message",
                component: () => import(/* webpackChunkName: "message" */ "@/views/permission/message/message.vue"),
                name: "Message",
                meta: {
                    title: "短信通知",
                    icon: "icon-caiwu",
                }
            },

            {
                path: "order",
                component: () => import(/* webpackChunkName: "order" */ "@/views/permission/message/order.vue"),
                name: "Order",
                meta: {
                    title: "订单消息",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "staff",
                component: () => import(/* webpackChunkName: "employee" */ "@/views/permission/staff/staff.vue"),
                name: "Staff",
                meta: {
                    title: "员工管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "apiAbnormal",
                component: () => import(/* webpackChunkName: "employee" */ "@/views/permission/apiAbnormal/apiAbnormal.vue"),
                name: "apiAbnormal",
                meta: {
                    title: "接口超时",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "roleEdit",
                component: () => import(/* webpackChunkName: "roleEdit" */ "@/views/permission/staff/roleEdit.vue"),
                name: "RoleEdit",
                meta: {
                    title: "角色编辑",
                    parentRoute: "/role",
                    cache: false
                }
            },
            {
                path: "role",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/role.vue"),
                name: "Role",
                meta: {
                    title: "角色管理",
                    icon: "icon-caiwu",
                }
            },
            {
                path: "customerService",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/customerService.vue"),
                name: "CustomerService",
                meta: {
                    title: "客服管理",
                    icon: "icon-caiwu",
                }
            },

            {
                path: "customerEdit",
                component: () => import(/* webpackChunkName: "role" */ "@/views/permission/staff/customerEdit.vue"),
                name: "CustomerEdit",
                meta: {
                    title: "编辑客服",
                    parentRoute: "/customerService",
                    cache: false
                }
            },
            {
                path: "menulist",
                component: () => import(/* webpackChunkName: "menulist" */ "@/views/permission/staff/menuList.vue"),
                name: "menulist",
                meta: {
                    title: "菜单管理",
                    icon: "el-icon-s-tools",
                }
            },
            {
                path: "userlog",
                component: () => import(/* webpackChunkName: "userlog" */ "@/views/permission/logs/userLog.vue"),
                name: "UserLog",
                meta: {
                    title: "用户操作日志",
                }
            },
            {
                path: "stafflog",
                component: () => import(/* webpackChunkName: "stafflog" */ "@/views/permission/logs/staffLog.vue"),
                name: "StaffLog",
                meta: {
                    title: "用户操作日志",
                }
            },
            {
                path: "importantlog",
                component: () => import(/* webpackChunkName: "importantlog" */ "@/views/permission/logs/importantLog.vue"),
                name: "Importantlog",
                meta: {
                    title: "重要操作日志",
                }
            },

            {
                path: "chat",
                component: () => import(/* webpackChunkName: "chat" */ "@/views/permission/content/chat.vue"),
                name: "Chat",
                meta: {
                    title: "聊天记录",
                    icon: "icon-caiwu"
                }
            },
            {
                path: "chatroom",
                component: () => import(/* webpackChunkName: "chatroom" */ "@/views/chat/chat.vue"),
                name: "ChatRoom",
                meta: { title: "客服会话", icon: "icon-caiwu", cache: false }
            },

            /**
             * 帮助中心
             */
            {
                path: "category",
                component: () => import(/* webpackChunkName: "category" */ "@/views/help/category.vue"),
                name: "category",
                meta: {
                    title: "分类管理",
                    icon: "el-icon-s-custom",
                }
            },
            {
                path: "merchant-manual",
                component: () => import("@/views/help/manual.vue"),
                name: "MerchantManual",
                meta: { title: "商户操作手册", icon: "el-icon-notebook-2", cache: false }
            },
            {
                path: 'tutorials',
                component: () => import('@/views/help/tutorials.vue'),
                name: 'Tutorials',
                meta: { title: '教程管理', icon: 'el-icon-video-camera', cache: false }
            },
            {
                path: "articles",
                component: () => import(/* webpackChunkName: "articles" */ "@/views/help/articles.vue"),
                name: "articles",
                meta: {
                    title: "文章列表",
                    icon: "el-icon-s-custom",
                }
            },
            {
                path: "modify",
                component: () => import(/* webpackChunkName: "modify" */ "@/views/help/modify.vue"),
                name: "modify",
                meta: {
                    title: "编辑文章",
                    // parentRoute: "/ordermanage",
                    cache: false
                }
            },

            /*
            * 白名单
            */
            {
                path: "whitelist",
                component: () => import(/* webpackChunkName: "whitelist" */ "@/views/permission/whiteList/whiteList.vue"),
                name: "WhiteList",
                meta: {
                    title: "白名单",
                    icon: "el-icon-s-custom",
                }
            },


            /**
             * 交易管理
             */

            //记账列表
            {
                path: 'account-list',
                component: () => import('@/views/club/account/account-list.vue'),
                name: 'account-list',
                meta: {
                    title: '记账列表'
                }
            },
            //工作记录
            {
                path: 'work-log',
                component: () => import('@/views/club/work-log/work-log.vue'),
                name: 'work-log',
                meta: {
                    title: '工作记录'
                }
            },
            {
                path: "sms-template",
                component: () => import(/* webpackChunkName: "message" */ "@/views/permission/message/sms-template.vue"),
                name: "SmsTemplate",
                meta: {
                    title: "短信模板",
                }
            },

            /**
             * 广告商管理
             */
            {
                path: "club-list",
                component: () => import(/* webpackChunkName: "club-list" */ "@/views/club/customers/customer-list.vue"),
                name: "club-list",
                meta: {
                    title: "商户列表"
                }
            },
            {
                path: "adsense-user",
                component: () => import(/* webpackChunkName: "adsense-user" */ "@/views/club/adsense/adsense-user.vue"),
                name: "adsense-user",
                meta: {
                    title: "客户认证"
                }
            },            {
                path: "merchant-domain",
                component: () => import(/* webpackChunkName: "merchant-domain" */ "@/views/club/domain/domain-list.vue"),
                name: "merchant-domain",
                meta: {
                    title: "域名绑定"
                }
            },
            {
                path: "esa-config",
                component: () => import(/* webpackChunkName: "esa-config" */ "@/views/club/domain/esa-config.vue"),
                name: "esa-config",
                meta: {
                    title: "ESA参数"
                }
            },
            {
                path: "merchant-pay-config",
                component: () => import(/* webpackChunkName: "merchant-pay-config" */ "@/views/club/pay/merchant-pay-list.vue"),
                name: "merchant-pay-config",
                meta: {
                    title: "商户收款配置"
                }
            },
            {
                path: "platform-pay-config",
                component: () => import(/* webpackChunkName: "platform-pay-config" */ "@/views/club/pay/platform-pay-config.vue"),
                name: "platform-pay-config",
                meta: {
                    title: "平台经营配置"
                }
            },
            { path: 'gift-assets', name: 'gift-assets', component: () => import('@/views/club/pay/gift-assets.vue'), meta: { title: '打赏素材库' } },
            {
                path: "adsense-page",
                component: () => import(/* webpackChunkName: "adsense-page" */ "@/views/club/adsense/adsense-page.vue"),
                name: "adsense-page",
                meta: {
                    title: "广告商产品"
                }
            },
            {
                path: "adsense-url",
                component: () => import(/* webpackChunkName: "adsense-url" */ "@/views/club/adsense/adsense-url.vue"),
                name: "adsense-url",
                meta: {
                    title: "广告商链接"
                }
            },
            {
                path: "adsense-kf",
                component: () => import(/* webpackChunkName: "adsense-kf" */ "@/views/club/adsense/adsense-kf.vue"),
                name: "adsense-kf",
                meta: {
                    title: "广告商客服"
                }
            },
            {
                path: "adsense-banner",
                component: () => import(/* webpackChunkName: "adsense-banner" */ "@/views/club/adsense/adsense-banner.vue"),
                name: "adsense-banner",
                meta: {
                    title: "轮播图"
                }
            },
            {
                path: "adsense-log",
                component: () => import(/* webpackChunkName: "adsense-log" */ "@/views/club/adsense/adsense-log.vue"),
                name: "adsense-log",
                meta: {
                    title: "操作日志"
                }
            },
            {
                path: "adsense-icon",
                component: () => import(/* webpackChunkName: "adsense-icon" */ "@/views/club/adsense/adsense-icon.vue"),
                name: "adsense-icon",
                meta: {
                    title: "快捷图标"
                }
            },
            {
                path: "adsense-badge",
                component: () => import(/* webpackChunkName: "adsense-badge" */ "@/views/club/adsense/adsense-badge.vue"),
                name: "adsense-badge",
                meta: {
                    title: "角标设置"
                }
            },
            {
                path: "adsense-banner-resource",
                component: () => import(/* webpackChunkName: "adsense-banner-resource" */ "@/views/club/adsense/adsense-banner-resource.vue"),
                name: "adsense-banner-resource",
                meta: {
                    title: "轮播图素材"
                }
            },
            {
                path: "adsense-limit",
                component: () => import(/* webpackChunkName: "adsense-limit" */ "@/views/club/adsense/adsense-limit.vue"),
                name: "adsense-limit",
                meta: {
                    title: "默认额度"
                }
            },
            {
                path: "vip-type",
                component: () => import(/* webpackChunkName: "vip-type" */ "@/views/club/adsense/vip-type.vue"),
                name: "vip-type",
                meta: {
                    title: "VIP套餐"
                }
            },
            {
                path: "vip-order",
                component: () => import(/* webpackChunkName: "vip-order" */ "@/views/club/adsense/vip-order.vue"),
                name: "vip-order",
                meta: {
                    title: "开通与续费记录"
                }
            },
            {
                path: "face-manage",
                component: () => import(/* webpackChunkName: "face-manage" */ "@/views/club/adsense/face-manage.vue"),
                name: "face-manage",
                meta: {
                    title: "实名管理"
                }
            },
            {
                path: 'subscriptions',
                component: () => import('@/views/club/customers/customer-list.vue'),
                name: 'CustomerSubscriptions',
                meta: {title: '订阅管理'}
            },
            {
                path: 'customer-detail',
                component: () => import('@/views/club/customers/customer-detail.vue'),
                name: 'CustomerDetail',
                meta: {title: '客户详情', parentRoute: '/club-list', activeMenu: '/club-list'}
            },
            {
                path: 'customer-users',
                component: () => import('@/views/club/customers/customer-users.vue'),
                name: 'CustomerUsers',
                meta: {title: '客户内用户'}
            },
            {
                path: 'customer-phone',
                component: () => import('@/views/club/customers/customer-phone.vue'),
                name: 'CustomerPhone',
                meta: {title: '手机号查询'}
            },
            {
                path: 'customer-followups',
                component: () => import('@/views/club/customers/customer-followups.vue'),
                name: 'CustomerFollowups',
                meta: {title: '客户跟进'}
            },
            {
                path: 'customer-feedback',
                component: () => import('@/views/club/customers/customer-feedback.vue'),
                name: 'CustomerFeedback',
                meta: {title:'客户反馈处理'}
            },
            {
                path:'customer-analytics',
                component:()=>import('@/views/club/customers/customer-analytics.vue'),
                name:'CustomerAnalytics',
                meta:{title:'客户经营分析'}
            },
            {path:'customer-classification',component:()=>import('@/views/club/customers/customer-classification.vue'),name:'CustomerClassification',meta:{title:'客户分类'}},
            {path:'customer-orders',component:()=>import('@/views/club/customers/customer-orders.vue'),name:'CustomerOrders',meta:{title:'商户订单'}},
            {path:'customer-fund-log',component:()=>import('@/views/club/customers/customer-fund-log.vue'),name:'CustomerFundLog',meta:{title:'资金日志'}},
            {path:'customer-operation-log',component:()=>import('@/views/club/customers/customer-operation-log.vue'),name:'CustomerOperationLog',meta:{title:'商户操作日志'}},
            {path:'customer-cash',component:()=>import('@/views/club/customers/customer-cash.vue'),name:'CustomerCash',meta:{title:'提现日志'}},
            {path:'merchant-logout',component:()=>import('@/views/club/customers/merchant-logout.vue'),name:'MerchantLogout',meta:{title:'商户注销管理'}},
        ]
    },
];


const createRouter = () =>
    new VueRouter({
        mode: 'history',
        scrollBehavior: (to, from, savedPosition) => {
            if (savedPosition) {
                return savedPosition;
            } else {
                return { x: 0, y: 0 };
            }
        },
        base: process.env.BASE_URL,
        routes: [...constantRoutes, ...asyncRoutes]
    });

const router = createRouter();

// 发版后旧标签页的资源加载失败兜底 + 新版软提示
setupAppUpdate(router);

export default router;
